import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (err) {
    return true;
  }
};

const ProtectedRoute = ({ children }) => {
  const { token, logout } = useContext(AuthContext);

  if (!token || isTokenExpired(token)) {
    if (token) {
      // Token exists but expired, logout
      logout();
    }
    return <Navigate to="/app" replace />;
  }

  return children;
};

export default ProtectedRoute;
